'use client';

import { type FC, type PropsWithChildren, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Compress, ExpandedOutline } from '@eqi-investimentos/icons/web';
import { Flex, Heading, type FlexProps } from '@eqi-investimentos/react';
import { IconButton } from '@/components/atoms/IconButton';
import { IfRender } from '@/utils/jsx';
import { MonetaryVisibilityButton } from '../MonetaryVisibilityButton';
export const ExpansibleCard: FC<PropsWithChildren<ExpansibleCardProps>> = ({
  children,
  id = crypto.randomUUID(),
  expandedHeight,
  title,
  showMonetaryButton
}) => {
  const {
    t
  } = useTranslation('common');
  const [isExpanded, setIsExpanded] = useState(true);
  return <Flex id={id} display="inline-flex" flexDir="column" w="calc(100% - 2rem)" h={['5.25rem', expandedHeight][Number(isExpanded)]} gap="l" p="2xl" bgColor="background.brandLight" borderRadius="lg" overflow="hidden" transition="all 500ms ease-in-out" data-sentry-element="Flex" data-sentry-component="ExpansibleCard" data-sentry-source-file="index.tsx">
      <Flex justifyContent="space-between" alignItems="center" w="full" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Flex flexDir="row" alignItems="center" w="full" gap="15px" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Heading as="h4" fontSize="lg" fontWeight="normal" lineHeight="6" color="content.primary" data-sentry-element="Heading" data-sentry-source-file="index.tsx">
            {title}
          </Heading>
          <IfRender condition={!!showMonetaryButton} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
            <MonetaryVisibilityButton widgetId={id} data-sentry-element="MonetaryVisibilityButton" data-sentry-source-file="index.tsx" />
          </IfRender>
        </Flex>
        <IconButton ariaLabel={[t('attributes.expand'), t('attributes.collapse')][Number(isExpanded)]} icon={[ExpandedOutline, Compress][Number(isExpanded)]} onButtonClick={() => setIsExpanded(!isExpanded)} buttonProps={{
        justifyContent: 'flex-end',
        w: '3.125rem',
        _hover: {
          svg: {
            color: 'content.brand'
          }
        }
      }} iconProps={{
        w: 6,
        h: 6,
        color: 'content.brand'
      }} data-sentry-element="IconButton" data-sentry-source-file="index.tsx" />
      </Flex>
      <Flex display="inline-flex" alignItems="center" columnGap="5" w="full" h="auto" opacity={Number(isExpanded)} transitionProperty="all" transitionTimingFunction="cubic-bezier(0.4, 0, 0.2, 1)" transitionDuration="500ms" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {children}
      </Flex>
    </Flex>;
};
type ExpansibleCardProps = {
  id?: string;
  expandedHeight: FlexProps['h'];
  title: string;
  showMonetaryButton?: boolean;
};